import { BkFillType, ToolMode, IWhiteBoard } from '@volcengine/white-board-manage';
import { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- 临时屏蔽 STS 上传入口后恢复使用
import { Radio, Divider, Button, Space, Upload, message } from 'antd';
import { useSelector } from '@/store';
import styles from './index.module.less';
import ColorPicker from '../ColorPicker';
import ImgUrlButton from '../ImageUrlButton';
import { PopType } from '../types';
import ChartChoose from '../ChartChoose';
import uploadFile, { getTosConfig } from '@/core/tos';
import Brushthickness from '../BrushThickness';

const range = [40, 70, 100];
const textRange = [300, 500, 700];

const ShapeDesc = {
  [ToolMode.CIRCLE]: '(按住shift可绘制正圆)',
  [ToolMode.RECT]: '(按住shift可绘制正方形)',
  [ToolMode.LINE]: '(按住shift可绘制水平/垂直线)',
  [ToolMode.ARROW]: '(按住shift可绘制水平/垂直线)',
};

interface PopModalProps {
  setBrushColor: (color: string) => void;
  brushColor: string;
  setBrushThickness?: (size: number) => void;
  brushThickness?: number;
  whiteBoard: IWhiteBoard;
  kind: PopType;
  mode: ToolMode | 'background' | undefined;
  onToolChange: (key: ToolMode) => void;
}

const kindMap = {
  [PopType.pencilBrush]: '画笔大小',
  [PopType.shape]: '线条粗细',
  [PopType.textbox]: '文字大小',
  [PopType.background]: '',
};

function PopModal(props: PopModalProps) {
  const stsParam = useSelector((state) => state.sts);
  const [fillType, setFillType] = useState<BkFillType>(BkFillType.kFill);
  const [backgroundType, setBackGroundType] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const {
    whiteBoard,
    setBrushColor,
    setBrushThickness,
    kind,
    onToolChange,
    mode,
    brushThickness,
    brushColor,
  } = props;
  // 画笔颜色
  const handleOnBrushColorChange = (color: {
    rgb: { r: number; g: number; b: number; a?: number };
  }) => {
    const c = color.rgb;
    const brushColor = `rgba(${c.r},${c.g},${c.b},255)`;
    whiteBoard.setShapeColor(brushColor);
    whiteBoard.setPenColor(brushColor);
    whiteBoard.setTextColor(brushColor);
    setBrushColor(brushColor);
  };
  const handleOnBrushThicknessChange = (current: number) => {
    whiteBoard.setShapeSize(range[current]);
    whiteBoard.setPenSize(range[current]);
    whiteBoard.setTextFontSize(textRange[current]);
    setBrushThickness && setBrushThickness(current);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- 临时屏蔽 STS 上传入口后恢复使用
  const handleUpload = async (file: File) => {
    if (isUploading) {
      message.warning('存在上传任务进行中');
      return;
    }
    setIsUploading(true);

    try {
      const tosConfig = await getTosConfig(stsParam);
      const url = await uploadFile(
        {
          key: tosConfig.key || '',
          file,
        },
        tosConfig
      );

      if (backgroundType === 0) {
        whiteBoard.setPageBackground({
          bkImage: url,
          bkImageFillType: fillType,
        });
      } else {
        whiteBoard.setBoardBackground({
          bkImage: url,
          bkImageFillType: fillType,
        });
      }
    } catch (error) {
      message.error((error as Error).message);
    } finally {
      setIsUploading(false);
    }

    return false;
  };

  return (
    <>
      {kind === PopType.shape && (
        <>
          <span className={styles.title}>
            形状类型
            <span className={styles.shapeDesc}>
              {ShapeDesc[mode as ToolMode as keyof typeof ShapeDesc]}
            </span>
          </span>
          <ChartChoose onToolChange={onToolChange} mode={mode as ToolMode} />
        </>
      )}
      {kind !== PopType.background && (
        <>
          <span className={styles.title}>{kindMap[kind]}</span>

          <Brushthickness
            current={brushThickness || 0}
            onChange={(current) => handleOnBrushThicknessChange(current)}
            items={[
              {
                label: '小',
                size: 0,
              },
              {
                label: '中',
                size: 1,
              },
              {
                label: '大',
                size: 2,
              },
            ]}
          />
        </>
      )}
      <span className={styles.title}>{`${kind === PopType.background ? '背景' : '画笔'}颜色`}</span>
      <ColorPicker color={brushColor} onChange={handleOnBrushColorChange} />
      {kind === PopType.background && (
        <>
          <Radio.Group value={backgroundType} onChange={(e) => setBackGroundType(e.target.value)}>
            <Radio value={0}>当前</Radio>
            <Radio value={1}>全局</Radio>
          </Radio.Group>
          <Divider className={styles.divider} />
          <Button
            onClick={() => {
              if (backgroundType === 0) {
                whiteBoard.setPageBackground({
                  bkColor: brushColor,
                });
              } else {
                console.log('brushColor', brushColor);
                whiteBoard.setBoardBackground({
                  bkColor: brushColor,
                });
              }
            }}
          >
            设置背景色
          </Button>
          <Divider className={styles.divider} />
          <Space direction="vertical">
            <Radio.Group value={fillType} onChange={(e) => setFillType(e.target.value)}>
              <Radio value={BkFillType.kFill}>fill</Radio>
              <Radio value={BkFillType.kCenter}>center</Radio>
              <Radio value={BkFillType.kHidden}>hidden</Radio>
            </Radio.Group>
            {/* 临时屏蔽：该入口依赖 STS，取消本段注释即可恢复本地背景图片上传。
            <Upload
              beforeUpload={handleUpload}
              showUploadList={false}
              accept=".jpg,.jpeg,.png,.bmp"
            >
              <Button>添加本地图片背景</Button>
            </Upload>
            */}
            <ImgUrlButton whiteBoard={whiteBoard} fillType={fillType} />
          </Space>
          <Divider className={styles.divider} />
          <Button
            onClick={() =>
              whiteBoard.setPageBackground({
                bkColor: undefined,
                bkImage: undefined,
              })
            }
          >
            清空当前页背景
          </Button>
          <Button
            style={{ marginLeft: 10 }}
            onClick={() =>
              whiteBoard.setBoardBackground({
                bkColor: undefined,
                bkImage: undefined,
              })
            }
            // disabled={file?.type !== FileType.whiteBoard}
          >
            清空全局页背景
          </Button>
        </>
      )}
    </>
  );
}

export default PopModal;
